// extracted by mini-css-extract-plugin
export default {"root":"DevicePill_root__HN4sI","text":"DevicePill_text__ujZAL"};